<div class="modal-header">
  {{verb}} Playbook
  <i class="material-icons" #closebtn data-bs-dismiss="modal" (click)='closeModal()'>close</i>
</div>
<form #playbookForm="ngForm">
  <div class="modal-body" style="max-height: fit-content;">
    <div class="form-group">
      <div class="row align-items-center">
        <label class="col-sm-4 control-label">Title</label>
        <div class="col-sm-8">
          <input name="playbookTitle" [(ngModel)]="playbook.title" type="text"
            class="form-control vplaybook__form__inputs" required>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <label class="col-sm-4 control-label pt-0">Description</label>
        <div class="col-sm-8">
          <app-rich-text-editor #notes name="notes" [(ngModel)]="playbook.description">
          </app-rich-text-editor>
        </div>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  @if (playbook?.id) {
    <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" (click)="deletePlaybook()">
      Delete
    </button>
  }
  <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal" (click)='closeModal()'>Close</button>
  <button type="submit" class="btn btn__btn-default btn__orange" (click)="savePlaybook()"
  [ngClass]="{'custom-btn-disabled': playbookForm.invalid}" [disabled]="playbookForm.invalid">Save</button>
</div>
